import { fetchVehicleNoSuggestions, normalizeVehiclePlateColor } from '@/utils/vehicleDataList'

export default {
  props: {
    /** 使用本系统正常车辆列表提供车牌联想。 */
    vehicleDataAutocomplete: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    vehiclePlateRemoteEnabled() {
      return Boolean(this.vehicleNoRemoteSelect || this.vehicleDataAutocomplete)
    }
  },
  methods: {
    async fetchVehicleNoFromDataList(contacts) {
      return fetchVehicleNoSuggestions(contacts)
    },
    applyVehicleNoPlateColor(item) {
      if (!item || !this.searchForm) return
      const color = normalizeVehiclePlateColor(item.vehiclePlateColor)
      this.searchForm.licensePlateColor = color
    },
    onVehiclePlateFromListSelected(item) {
      if (!item) return
      const v = item.value != null ? String(item.value).trim() : ''
      if (v) this.searchForm.licensePlate = v
      this.applyVehicleNoPlateColor(item)
    }
  }
}
